import { useState, useContext } from "react";
import { Checkbox, Loader, Table } from "rsuite";
import Select from 'react-select'

import MissedCalls from "./MissedCalls";
import RejectedSuppliers from "./RejectedSuppliers";
import Emails from "./Emails";
import PartnerSubmissions from "./PartnerSubmissions";
import { CONSTANTS } from "../../../../utils/constants/constants";
import EmailHeader from "./Headers/Email";
import MissedCallHeader from "./Headers/MissedCall";
import RejectedSupplierHeader from "./Headers/RejectedSupplier";
import PartnerSubmissionHeader from "./Headers/PartnerSubmission";
import { AppContext } from "../../../../context";
import { useStore } from "react-redux";

const { Pagination } = Table

const NotificationList = ({ notifications, subTab, setSubTab, currentPage, setCurrentPage, setSelectedNotification, pageNo, setPageNo, offset, setOffset, getNewUnreadNotification, getNotificationsUnifiedHandler, limit, totalNotification, setLimit, searchValue, setSearchValue, updateAction, setUpdateAction, filter, setFilter, updateActionHandler, filterHandler, notificationLoader, action, setAction, setFilterValue, setActionModal, actionModal, onCloseModal, onUpdate, setCheckedKeys, checkedKeys, isCancelledRef, filterValue }) => {
    const [activePage, setActivePage] = useState(1)
    const { setPartnerFilter, notificationCheckbox, setNotificationCheckbox } = useContext(AppContext);

    const store = useStore().getState();
    const { auth, sideMenu } = store;

    const tabs = [
        { label: 'Email', value: 'emails' },
        { label: 'Missed Calls', value: 'missedCalls' },
        { label: 'Rejected Suppliers', value: 'rejectedSuppliers' },
        { label: 'Partner Submission', value: 'partnerSubmissions' },
    ]

    const filterList = [
        { label: 'All', value: 'all' },
        { label: 'Read', value: 'read' },
        { label: 'Unread', value: 'unread' },
    ]

    const actionList = [
        { label: 'Mark As Read', value: 'markAsRead' },
        { label: 'Mark As Unread', value: 'markAsUnread' },
        { label: 'Delete', value: 'delete' },
    ]

    const onChangeTab = (tab) => {
        tab === CONSTANTS.NOTI_SUB_TABS.EMAILS ? setSubTab(CONSTANTS.NOTI_SUB_TABS.EMAILS) :
            tab === CONSTANTS.NOTI_SUB_TABS.PARTNER_SUBMISSIONS ? setSubTab(CONSTANTS.NOTI_SUB_TABS.PARTNER_SUBMISSIONS) :
                tab === CONSTANTS.NOTI_SUB_TABS?.MISSED_CALLS ? setSubTab(CONSTANTS.NOTI_SUB_TABS?.MISSED_CALLS) : setSubTab(CONSTANTS.NOTI_SUB_TABS?.REJECTED_SUPPLIERS)
        setCheckedKeys([])
        setFilterValue({ label: 'Unread', value: 'unread' })
        setNotificationCheckbox(false)
    }

    const onPageChange = (page) => {
        setActivePage(page)
        getNotificationsUnifiedHandler({ isSearch: searchValue ? true : false, searchValue, limit, offset: limit * (page - 1), filterValue, isCancelledRef, notificationCheckbox });
    }

    const handleChangeLimit = (tmpLimit) => {
        setLimit(tmpLimit)
    }

    const onChangeActionAndFilter = (e, type) => {
        if (type === 'action') {
            setAction(e)
            setActionModal(true)
        } else if (type === 'filter') {
            setFilterValue(e)
            setPartnerFilter(e?.value)
        }
    }

    const onSearch = () => {
        getNotificationsUnifiedHandler({ isSearch: searchValue ? true : false, searchValue, limit, offset, filterValue, isCancelledRef, notificationCheckbox })
    }

    const onReset = () => {
        setSearchValue('')
        getNotificationsUnifiedHandler({ isSearch: false, searchValue: '', limit: 10, offset: 0, filterValue: 'all', isCancelledRef, notificationCheckbox })
    }

    const handleAdminCheckbox = () => {
    setNotificationCheckbox((prev)=>!prev);
    getNotificationsUnifiedHandler({ isSearch: searchValue ? true : false, searchValue, limit, offset, filterValue, isCancelledRef, notificationCheckbox: !notificationCheckbox })
  }

    return (
        <div className="d-flex flex-column h-100 py-4 border">
            <div className="d-flex">
                <div className="my-3 px-4 d-flex column-gap-5">
                {tabs.map((tab) => (
                    <h4
                        key={tab.value}
                        style={{
                            color: tab.value === subTab ? '#214466' : '',
                            borderBottom: tab.value === subTab ? '4px solid #214466' : '',
                            width: tab.value === subTab ? 'auto' : '',
                            display: 'inline-block',
                            paddingBottom: tab.value === subTab ? '5px' : '',
                            cursor: 'pointer'
                        }}
                        className="fw-bold"
                        onClick={() => { onChangeTab(tab.value) }}
                    >
                        {tab.label}
                    </h4>
                ))}
                </div>
                {auth?.user?.roleName === "admin" ? (
                    <div className="ms-auto me-4">
                    <Checkbox
                      onChange={() => handleAdminCheckbox()}
                      checked={notificationCheckbox}
                    >
                      <h5 className='fw-bold'>Show All Users Notification</h5>
                    </Checkbox>
                    </div>
                  ) : null}
            </div>

            <div className="w-100 d-flex px-4 mb-3" style={{ height: 40 }}>
                <div className="w-50 h-100 d-flex">
                    <div className="d-flex align-items-center position-relative h-100 w-100 column-gap-3">
                        <input
                            className="form-control w-50 h-100 fs-4"
                            value={searchValue}
                            onChange={(e) => { setSearchValue(e?.target?.value) }}
                        />
                        <button className="icon-button-success" onClick={onSearch}>Search</button>
                        <button className="icon-button-success" onClick={onReset}>Reset</button>
                    </div>
                </div>

                <div className="w-50 h-100 d-flex column-gap-4 justify-content-end">
                    <Select
                        className="basic-single w-25 fs-4"
                        classNamePrefix="select"
                        value={action}
                        options={subTab === CONSTANTS.NOTI_SUB_TABS.PARTNER_SUBMISSIONS ? actionList?.slice(0, 2) : actionList}
                        onChange={(e) => { onChangeActionAndFilter(e, 'action') }}
                        isDisabled={checkedKeys?.length === 0}
                    />
                    <Select
                        className="basic-single w-25 fs-4"
                        classNamePrefix="select"
                        value={filterValue}
                        options={filterList}
                        onChange={(e) => { onChangeActionAndFilter(e, 'filter') }}
                    />
                </div>
            </div>

            <div className="d-flex flex-column flex-grow-1 overflow-hidden">
                {notificationLoader ? (
                    <div className="d-flex align-items-center justify-content-center flex-grow-1">
                        <Loader />
                    </div>
                ) : Object?.keys(notifications)?.length > 0 ? (
                    <>
                        <div className="px-4">
                            {subTab === 'emails' ? <EmailHeader /> :
                                subTab === 'missedCalls' ? <MissedCallHeader /> :
                                    subTab === 'rejectedSuppliers' ? <RejectedSupplierHeader /> :
                                        <PartnerSubmissionHeader />}
                        </div>

                        <div className="px-4 flex-grow-1 overflow-auto no-scrollbar">
                            {subTab === 'emails' ? (
                                <Emails
                                    notifications={notifications}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    setSelectedNotification={setSelectedNotification}
                                    setCheckedKeys={setCheckedKeys}
                                />
                            ) : subTab === 'missedCalls' ? (
                                <MissedCalls
                                    notifications={notifications}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    setSelectedNotification={setSelectedNotification}
                                    setCheckedKeys={setCheckedKeys}
                                    getNotificationsUnifiedHandler={getNotificationsUnifiedHandler}
                                    searchValue={searchValue}
                                    limit={limit}
                                    offset={offset}
                                    filterValue={filterValue}
                                    isCancelledRef={isCancelledRef}
                                />
                            ) : subTab === 'rejectedSuppliers' ? (
                                <RejectedSuppliers
                                    notifications={notifications}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    setSelectedNotification={setSelectedNotification}
                                    setCheckedKeys={setCheckedKeys}
                                    action={action}
                                    getNotificationsUnifiedHandler={getNotificationsUnifiedHandler}
                                    searchValue={searchValue}
                                    limit={limit}
                                    offset={offset}
                                    filterValue={filterValue}
                                    isCancelledRef={isCancelledRef}
                                />
                            ) : (
                                <PartnerSubmissions
                                    notifications={notifications}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    setSelectedNotification={setSelectedNotification}
                                    setCheckedKeys={setCheckedKeys}
                                />
                            )}
                        </div>
                    </>
                ) : (
                    <div className="d-flex justify-content-center align-items-center flex-grow-1">
                        <p className="no-data-message">You have no notification right now</p>
                    </div>
                )}
            </div>

            <div className="d-flex align-items-center justify-content-end border-top" style={{ height: '64px' }}>
                <Pagination
                    prev
                    next
                    first
                    last
                    maxButtons={5}
                    activePage={activePage}
                    showInfo
                    displayLength={limit}
                    lengthMenu={CONSTANTS.LIMIT}
                    total={totalNotification}
                    onChangeLength={handleChangeLimit}
                    onChangePage={onPageChange}
                />
            </div>
        </div>
    );

}

export default NotificationList